export const API_HOST = "https://test.erp.ssiaeration.com"